<template>
    <div class="card">
        <div class="card-body">
            <div class="row m-2">
                <div class="col-6 p-l-0">
                    <h2 class="count-number">{{ countReaders.toString().replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ') }}</h2>
                    <span class="count">КІЛЬКІСТЬ ЧИТАЧІВ</span>
                </div>
                <div class="col-6 p-r-0 text-right">
                    <i class="mdi mdi-account-multiple index-icon"></i>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-12 p-r-0 p-l-0">
                    <div class="input-group">
                        <input type="text" name="s" @input="isTyping = true" v-model="searchReaders" class="form-control input-index" placeholder="Знайти читача">
                        <div class="input-group-btn">
                            <button type="submit" class="btn btn-link button-index">
                                <img src="/theme/icons/search.svg" width="24px">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div align="center" v-if="isLoading">
                <span>Пошук...</span>
            </div>
            <div class="row m-2" v-if="readersResult.length > 0">
                <div class="col-10 p-r-0 p-l-0">
                    <span class="search-result">Результати пошуку — знайдено {{ readersResult.length }}</span>
                </div>
                <div class="col-2 text-right p-r-0 p-l-0">
                    <i class="mdi mdi-close search-result" style="font-size: 20px" @click="searchReaders = ''; readersResult = []"></i>
                </div>

                <div class="p-t-10 w-100">
                    <a href="#" v-on:click.prevent="$root.searchReader(item.code)" v-for="(item,i) in readersResult" style="width: 100%">
                        <table>
                            <tr>
                                <td class="reader-avatar">
                                    <div class="dropify-wrapper" :class="item.debtor_days ? 'debtor' : ''">
                                        <div class="dropify-preview" style="display: block; padding: 0px;">
                                        <span class="dropify-render" :style="'background: url(' + (item.photo ? '/uploads/' + item.photo : '/images/avatar.png') +')'">
<!--                                            <img v-bind:src="'/uploads/' + item.photo" alt="" class="rounded float-left">-->
                                        </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="reader" :class="item.debtor_days ? 'debtor' : ''">
                                    {{ item.fullname }}
                                    <img v-if="item.books.some(el=>el.library_id == $root.$data.libraryId)" src="/theme/icons/has-book.svg" class="has-book">
                                </td>
                            </tr>
                        </table>
                        <hr v-if="i != readersResult.length - 1" style="width: 100%">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lodash from 'lodash';
    export default {
        name: "SearchReader",
        data(){
            return {
                countReaders:0,
                searchReaders:'',
                isTyping: false,
                isLoading: false,
                readersResult: [],
            }
        },
        watch: {
            searchReaders: _.debounce(function() {
                this.isTyping = false;
            }, 1000),
            isTyping: function(value) {
                if (!value) {
                    this.searchReadersAction(this.searchReaders);
                }
            }
        },
        mounted() {
          this.getCount();
        },
        methods:{
            getCount(){
              axios.get('/api/counts-readers?library=' + this.$root.$data.libraryId)
                  .then(response => {
                    this.countReaders = response.data.count;
                  });
            },
            searchReadersAction: function() {
                this.isLoading = true;
                axios.get('/api/library/readers?s=' + this.searchReaders + '&lib_id=' + this.$root.$data.libraryId)
                    .then(response => {
                        this.isLoading = false;
                        this.readersResult = response.data.readers.data;
                    });
            },
        },
    }
</script>

<style scoped>
    .reader-avatar{
        background: unset;
    }
    .reader-avatar:hover{
        background: unset;
    }

    .reader-avatar .dropify-wrapper {
        background: unset;
        border: 3px solid #A7AFBA;
        border-radius: 50%;
        width: 80px;
        height: 80px;
    }

    .search-result{
        font-size: 12px;
        color: #A7AFBA;
    }

    .reader-avatar .dropify-wrapper .dropify-preview .dropify-render {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 75px;
        height: 75px;
        overflow: hidden;
        background-size: cover !important;
        background-position: center !important;
    }

    .reader-avatar .dropify-wrapper.debtor{
        border: 3px solid #FE9780;
    }
    .reader-avatar .dropify-render img{
      height: auto;
      width: 100%;
    }

    .reader{
        padding-left: 15px;
        color: #414141;
        font-size: 18px;
    }
    .reader.debtor{
        color: #FE9780;
    }
    .has-book{
      position: absolute;
      right: 30px;
    }
</style>